import { IState } from 'reducers'

export const getAuthIsLoggedInSelector = (state: IState): boolean => state.auth.isLoggedIn
export const getAuthIsLoadingSelector = ({ auth }: IState): boolean => auth.isLoading
export const getAuthErrorMsgSelector = ({ auth }: IState): string => auth.errorMsg
export const getAuthTokenSelector = ({ auth }: IState): string | null => auth.token
